<template>
  <PopupModal :open="visible" @close="close">
    <template #header>
      <div>
        <AssistantSmiling class="mx-auto mb-8" />
      </div>
      <h3 class="text-lg leading-6 font-medium">
        {{ t("open.external.link.title") }}
      </h3>
    </template>
    <template #body>
      <div class="mt-2 text-left">
        <p class="text-medium" v-html="t('open.external.link.body')"></p>
      </div>
    </template>
    <template #footer>
      <div class="flex flex-row flex-wrap md:flex-nowrap gap-2 justify-center">
        <ButtonElement
          ref="cancelButtonRef"
          class="bg-white"
          :label="t('open.external.link.cancel.button.title')"
          :disabled-visible="true"
          @click="close"
        />
        <ButtonElement
          :label="t('open.external.link.confirm.button.title')"
          @click="redirect"
        />
      </div>
    </template>
  </PopupModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { defineEmits } from "vue";
import PopupModal from "./PopupModal.vue";
import AssistantSmiling from "../icon/AssistantSmiling.vue";
import ButtonElement from "../form/ButtonElement.vue";

const { t } = useI18n();

const visible = ref(false);
const targetUrl = ref("");

const emit = defineEmits<{
  (e: "close"): void;
}>();

function close() {
  visible.value = false;
  emit("close");
}

function redirect() {
  close();
  window.open(targetUrl.value);
}

function openModal(url: string) {
  targetUrl.value = url;
  visible.value = true;
}

defineExpose({ openModal });
</script>
